module.exports = __webpack_public_path__ + "static/media/14122018-1.a55960ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/14122018-1.png
// module id = 1667
// module chunks = 0